var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"content__info"},[_c('h1',{staticClass:"content__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content__descr",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__logo"},[_c('img',{attrs:{"src":require("../assets/img/Logo.png"),"alt":"logo"}})])
}]

export { render, staticRenderFns }